import "../Styles/footer.css";
const Footer = () => {
  return (
    <div className="footer-div">
      <div className="footer-button">
        <p>Created By <span>Sagar</span> | &copy; 2022 All rights reserved</p>
        {/* <div className="footer-box">C</div>
    <div className="footer-box">H</div>
    <div className="footer-box">A</div>
    <div className="footer-box">V</div>
    <div className="footer-box">A</div>
    <div className="footer-box">N</div> */}
      </div>
    </div>
  );
};

export default Footer;
